





















import { Component, Vue } from 'vue-property-decorator'
import { getOperationID } from '@/api/operations'
import { ApiService } from '@/api/api.service'

@Component({})
export default class ProgAlert extends Vue {
    currentAlertIdx = 0
    alertMsgs: string[] = []
    containerWidth = 100
    intervalId = null

    async mounted() {
        const apiService = new ApiService()

        try {
            const opeID = await getOperationID()
            const alertResp = await apiService.getAlerts(opeID)

            this.alertMsgs = this.shuffleMsgs(
                alertResp.data.map(alert => alert.message)
            )

            this.containerWidth = 100 * this.alertMsgs.length

            this.setupInterval()
        } catch {}
    }

    setupInterval() {
        if (this.intervalId != null) {
            clearInterval(this.intervalId)
        }

        this.intervalId = setInterval(() => {
            this.currentAlertIdx =
                (this.currentAlertIdx + 1) % this.alertMsgs.length
        }, 10000)
    }

    shuffleMsgs(alertMsgs) {
        for (let i = alertMsgs.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1))
            ;[alertMsgs[i], alertMsgs[j]] = [alertMsgs[j], alertMsgs[i]]
        }
        return alertMsgs
    }

    previousMsg() {
        this.setupInterval()
        this.currentAlertIdx = this.currentAlertIdx - 1

        if (this.currentAlertIdx < 0) {
            this.currentAlertIdx += this.alertMsgs.length
        }
    }

    nextMsg() {
        this.setupInterval()
        this.currentAlertIdx =
            (this.currentAlertIdx + 1) % this.alertMsgs.length
    }
}
